export interface CreditCardServiceOptions {
  removeWhitespace?: boolean;
  throwOnMismatch?: boolean;
}
